export default "__VITE_ASSET__fc270770__"